var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-rdh-c88": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "_ngcontent-rdh-c88": "",
    x: 2.5,
    y: 2,
    width: 9,
    height: 11,
    stroke: "#013d50"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "_ngcontent-rdh-c88": "",
    x: 4.25,
    y: 3.93164,
    width: 5.36719,
    height: 2.87915,
    fill: "#013d50"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "_ngcontent-rdh-c88": "",
    x: 4.25,
    y: 8.19336,
    width: 5.36719,
    height: 1.07565,
    fill: "#013d50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/Calculator.f5fa598a2ad6165ebb56a016de96d7d0.svg";
export { ForwardRef as ReactComponent };